import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { getAssetUrl } from '../../../../utils/config';
import './style.scss';

type DeliveryForecastProps = {
  deliveryForecast: { deliverable?: string; subsequentDelivery?: string };
};

const DeliveryForecast = ({ deliveryForecast }: DeliveryForecastProps) => {
  const soldOut = deliveryForecast.subsequentDelivery === 'outsold' || deliveryForecast.deliverable === 'outsold';
  return (
    <div className="delivery-forecast">
      <div className={classNames('chip', { 'sold-out': soldOut })}>
        {!soldOut && (
          <img
            className="chip__icon"
            src={getAssetUrl(`basket/delivery${deliveryForecast.deliverable ? 'Success' : 'Clock'}.svg`)}
          />
        )}

        <FormattedMessage
          id={`shipping.carrier.deliveryForecast.${
            deliveryForecast.deliverable ?? deliveryForecast.subsequentDelivery
          }`}
        />
      </div>
    </div>
  );
};

export default DeliveryForecast;
